import { useState } from "react";

const faqs = [
  {
    q: "漂亮的保姆主要提供什么内容？",
    a: "我们专注影视剧资讯、剧情介绍与解析，内容涵盖最新剧集动态、详细剧情速览、分集解析以及演员资料，帮助观众系统化地了解一部剧。",
  },
  {
    q: "网站上的剧集信息是实时的吗？",
    a: "当前网站内容为前端演示数据，用于展示信息结构与浏览体验，尚未接入真实内容接口，剧集信息可能与实际播出情况存在差异。",
  },
  {
    q: "搜索和收藏功能如何使用？",
    a: "顶部搜索框支持按剧集名称、演员或关键词模糊检索。收藏功能会将你喜欢的剧集保存在本地浏览器中，刷新页面后依然保留。",
  },
  {
    q: "可以投稿或合作吗？",
    a: "当然可以。欢迎通过本页的在线咨询表单留言，选择“合作洽谈”或“内容反馈”，我们会尽快与你联系。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1.5 h-6 rounded-full bg-secondary-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">
          常见问题
        </h2>
      </div>
      <div className="divide-y divide-background-200">
        {faqs.map((f, i) => (
          <div key={f.q}>
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer"
            >
              <span className="font-medium text-sm md:text-base text-foreground-900">
                {f.q}
              </span>
              <i
                className={`shrink-0 text-xl text-primary-500 transition-transform ${
                  open === i ? "ri-subtract-line" : "ri-add-line"
                }`}
              />
            </button>
            {open === i && (
              <p className="pb-4 text-sm text-foreground-600 leading-relaxed animate-fade-in">
                {f.a}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}